import React, { useContext, useEffect, useState } from "react";
import { clBasic, HOY, lunesSemana, Scrudo, SEtiqueta, toInput, toOutput, Sfiltros, Sfiltro, SetiquetaFiltro, SfotoFiltro, SinputFiltro } from "./general";
import { AppContext } from "./index";
import Boton from "./Boton";
import ListaOpciones from "./ListaOpciones";

export default function RegistroHoras() {
  let { firebase, usrLogged } = useContext(AppContext);

  const [items, setItems] = useState([]);
  const [semana, setSemana] = useState(toInput(lunesSemana(HOY, 0)));
  const [persona, setPersona] = useState(usrLogged.id);
  const [totalHoras, setTotalHoras] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [total, setTotal] = useState(0);
  const [change, setChange] = useState(false)

  useEffect(() => {
    setItems(firebase.itemsHoras(persona, toOutput(semana)));
  }, [persona, semana, firebase]);

  useEffect(() => {
    document.getElementById("htmlTituloPag").innerHTML = "Registro de Horas";
    document.getElementById("htmlTituloPagS").innerHTML = "";
  }, []);

  useEffect(() => {
    let totales = [0, 0, 0, 0, 0, 0, 0];
    let total = 0;
    items.forEach((i) => {
      for (let x = 0; x < 7; x++) {
        total = total + i.horas[x];
        totales[x] = totales[x] + i.horas[x];
      }
    });
    setTotalHoras([...totales]);
    setTotal(total);
  }, [items]);

  function actualizarHoras() {
    console.log('actualizo')
    firebase.actualizarHoras(items, persona, toOutput(semana));
    setChange(false)
  }

  if (usrLogged.isLogged)
    return (
      <div style={SregistroHoras}>

        <div style={Sfiltros} >
          <div style={Sfiltro}>
            <div style={SetiquetaFiltro} >Persona:</div>
            <div style={SfotoFiltro} >
              {persona && <img src={persona !== "Todas" ? firebase.usuario(persona).url : null} alt={"?"} height="35px" width="35px"></img>}
            </div>
            <div id="UTPpersona" style={{ ...SinputFiltro, width: "18vw", marginLeft: "10px" }}  >
              {persona && (persona !== "Todas" ? firebase.usuario(persona).nombre : "Todas")}
            </div>
          </div>
          <div style={Sfiltro}>
            <div style={SetiquetaFiltro} >Semana:</div>
            <input id="UTPinicio" style={{ ...SinputFiltro, width: "11vw" }} type="date"
              value={semana}
              onChange={(e) => {
                e.persist();
                let s = lunesSemana(toOutput(e.target.value))
                setSemana(toInput(s));
              }}
              onBlur={(e) => {
                e.persist();
                let s = lunesSemana(toOutput(e.target.value))
                if (lunesSemana(HOY) < s || lunesSemana(HOY, 2) > s) {
                  alert('Solo puede actualizar horas en la semana corriente o hasta 2 anteriores')
                  s = lunesSemana(HOY)
                }
                setSemana(toInput(s));
              }}>
            </input>
          </div>
          {usrLogged.permisos.registroHoras && <ListaOpciones setFiltro={setPersona} lista={firebase.filtroPersonas} elemento="UTPpersona" titulo={"Persona"} />}
        </div >

        <div style={SitemTitulo}>
          <div></div>
          <div style={Setiqueta}>Lun</div>
          <div style={Setiqueta}>Mar</div>
          <div style={Setiqueta}>Mie</div>
          <div style={Setiqueta}>Jue</div>
          <div style={Setiqueta}>Vie</div>
          <div style={{ ...Setiqueta, color: "red" }}>Sab</div>
          <div style={{ ...Setiqueta, color: "red" }}>Dom</div>
        </div>
        <div style={Scrudo}>
          <div style={SlistaItems}>
            {items.map((i, ind) => (
              <div style={Sitem} key={ind}>
                <div style={SEtiqueta}>{i.tipo + "-" + i.id + "-" + i.nombre}</div>
                <input
                  style={Sinput}
                  type="number"
                  value={items[ind].horas[0]}
                  onChange={(e) => {
                    e.persist(); setChange(true);
                    let aux = [...items];
                    aux[ind].horas[0] = Number(e.currentTarget.value);
                    setItems([...aux]);
                  }}
                ></input>
                <input
                  style={Sinput}
                  type="number"
                  value={items[ind].horas[1]}
                  onChange={(e) => {
                    e.persist(); setChange(true);
                    let aux = [...items];
                    aux[ind].horas[1] = Number(e.currentTarget.value);
                    setItems([...aux]);
                  }}
                ></input>
                <input
                  style={Sinput}
                  type="number"
                  value={items[ind].horas[2]}
                  min="0"
                  max="24"
                  onChange={(e) => {
                    e.persist(); setChange(true);
                    let aux = [...items];
                    aux[ind].horas[2] = Number(e.currentTarget.value);
                    setItems([...aux]);
                  }}
                ></input>
                <input
                  style={Sinput}
                  type="number"
                  value={items[ind].horas[3]}
                  onChange={(e) => {
                    e.persist(); setChange(true);
                    let aux = [...items];
                    aux[ind].horas[3] = Number(e.currentTarget.value);
                    setItems([...aux]);
                  }}
                ></input>
                <input
                  style={Sinput}
                  type="number"
                  value={items[ind].horas[4]}
                  onChange={(e) => {
                    e.persist(); setChange(true);
                    let aux = [...items];
                    aux[ind].horas[4] = Number(e.currentTarget.value);
                    setItems([...aux]);
                  }}
                ></input>
                <input
                  style={Sinput}
                  type="number"
                  value={items[ind].horas[5]}
                  onChange={(e) => {
                    e.persist(); setChange(true);
                    let aux = [...items];
                    aux[ind].horas[5] = Number(e.currentTarget.value);
                    setItems([...aux]);
                  }}
                ></input>
                <input
                  type="number"
                  style={Sinput}
                  value={items[ind].horas[6]}
                  onChange={(e) => {
                    e.persist(); setChange(true);
                    let aux = [...items];
                    aux[ind].horas[6] = Number(e.currentTarget.value);
                    setItems([...aux]);
                  }}
                ></input>
              </div>
            ))}
          </div>
        </div>
        <div style={Spie}>
          <div style={SetiquetaP}>
            <div style={{ marginTop: "10px" }}>Total de horas de la semana</div>
            <div style={{ ...Scelda, color: `${firebase.usuario(persona).horassemana > total ? "red" : clBasic}`, fontWeight: 700, marginLeft: "10px" }}>
              {total}
            </div>
          </div>
          {totalHoras.map((t, ind) => (
            <div style={Scelda} key={ind}>
              {t}
            </div>
          ))}
        </div>

        <Boton accion={actualizarHoras} change={change} />
      </div>
    );
  else return <div style={{ color: clBasic }}>Debe loguearse, gil!!</div>;
}

const SregistroHoras = {
  margin: "15px",
};

const SitemTitulo = {
  fontSize: "2.2vh",
  display: "grid",
  gridTemplateColumns: " 46% 5.8% 5.8% 5.8% 5.8% 5.8% 5.8% 5.8%  12%",
  columnGap: "10px",
  marginLeft: "15px",
  marginBottom: "5px",
};

const SlistaItems = {
  height: "49vh",
  overflowY: "auto",
};

const Sitem = {
  display: "grid",
  gridTemplateColumns: " 46% 6% 6% 6% 6% 6% 6% 6% 12%",
  columnGap: "10px",
  overflow: "hidden",
  marginLeft: "15px",
  marginBottom: "5px",
  height: "7.5vh",
};

const Spie = {
  fontSize: "2.7vh",
  margin: "10px 0px 10px 0px",
  display: "grid",
  gridTemplateColumns: " 46% 5.8% 5.8% 5.8% 5.8% 5.8% 5.8% 5.8% 12%  ",
  columnGap: "10px",
  background: "#e6e6e6",
  borderRadius: "10px",
  color: clBasic,
  padding: "10px 0px 10px 0px",
};

const Scelda = {
  background: "#F5F6CE",
  borderRadius: "5px",
  color: clBasic,
  textAlign: "center",
  padding: "10px",
  border: "solid 2px #F2F5A9"
};

const Sinput = {
  background: "#e6e6e6",
  borderRadius: "5px",
  textAlign: "center",
  color: "#424242",
  padding: "4px",
};

const Setiqueta = {
  textAlign: "center",
  color: clBasic,
  fontWeight: 700,
  // padding: "10px 0px 10px 0px",
};

const SetiquetaP = {
  color: clBasic,
  fontWeight: 700,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
};



